import React from 'react';
import { DollarSign, ChevronUp, ChevronDown, Check } from 'lucide-react';

export default function BudgetSection({ filters, onChange, isExpanded, onToggleExpanded, onClear }) {
    const isActive = () => {
        const { hourlyRate, fixedPrice, onlyHourly, onlyFixed, hideNoBudget } = filters;
        return (
            hourlyRate?.min || hourlyRate?.max ||
            fixedPrice?.min || fixedPrice?.max ||
            onlyHourly || onlyFixed || hideNoBudget
        );
    };

    return (
        <div className="bg-white p-4 rounded-xl border border-gray-100 h-fit">
            <button
                type="button"
                className={`w-full flex items-center justify-between cursor-pointer ${isExpanded ? 'mb-4' : ''}`}
                onClick={onToggleExpanded}
            >
                <div className="flex items-center gap-2 font-semibold text-gray-700">
                    <DollarSign size={20} className="text-gray-400" />
                    <span>Job terms</span>
                </div>
                <div className="flex items-center gap-2">
                    {isActive() && (
                        <span className="bg-blue-100 text-blue-600 p-1 rounded-md flex items-center justify-center">
                            <Check size={14} strokeWidth={3} />
                        </span>
                    )}
                    {isExpanded ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
                </div>
            </button>

            {isExpanded && (
                <div className="space-y-4 animate-in fade-in slide-in-from-top-2 duration-200">

                    {isActive() && (
                        <div className="flex justify-end -mt-2">
                            <button
                                type="button"
                                onClick={onClear}
                                className="text-xs font-medium text-gray-400 hover:text-red-600 focus:outline-none transition-colors"
                            >
                                Clear
                            </button>
                        </div>
                    )}

                    {/* Hourly Rate */}
                    <div>
                        <label htmlFor="jf-hourly-min" className="block text-sm font-medium text-gray-900 mb-2">
                            Hourly rate, USD:
                        </label>
                        <div className="flex items-center gap-2">
                            <input
                                id="jf-hourly-min"
                                type="number"
                                placeholder="from, USD"
                                aria-label="Hourly rate from, USD"
                                value={filters.hourlyRate?.min || ''}
                                onChange={(e) => onChange({
                                    ...filters,
                                    hourlyRate: { ...filters.hourlyRate, min: e.target.value }
                                })}
                                className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 hover:border-blue-300 transition-colors"
                            />
                            <input
                                type="number"
                                placeholder="to, USD"
                                aria-label="Hourly rate to, USD"
                                value={filters.hourlyRate?.max || ''}
                                onChange={(e) => onChange({
                                    ...filters,
                                    hourlyRate: { ...filters.hourlyRate, max: e.target.value }
                                })}
                                className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 hover:border-blue-300 transition-colors"
                            />
                        </div>
                    </div>

                    {/* Fixed Price */}
                    <div>
                        <label htmlFor="jf-fixed-min" className="block text-sm font-medium text-gray-900 mb-2">
                            Fixed price, USD:
                        </label>
                        <div className="flex items-center gap-2">
                            <input
                                id="jf-fixed-min"
                                type="number"
                                placeholder="from, USD"
                                aria-label="Fixed price from, USD"
                                value={filters.fixedPrice?.min || ''}
                                onChange={(e) => onChange({
                                    ...filters,
                                    fixedPrice: { ...filters.fixedPrice, min: e.target.value }
                                })}
                                className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 hover:border-blue-300 transition-colors"
                            />
                            <input
                                type="number"
                                placeholder="to, USD"
                                aria-label="Fixed price to, USD"
                                value={filters.fixedPrice?.max || ''}
                                onChange={(e) => onChange({
                                    ...filters,
                                    fixedPrice: { ...filters.fixedPrice, max: e.target.value }
                                })}
                                className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 hover:border-blue-300 transition-colors"
                            />
                        </div>
                    </div>

                    <div className="space-y-2 pt-2">
                        <label className="flex items-center gap-2 cursor-pointer">
                            <input
                                type="checkbox"
                                checked={filters.onlyHourly || false}
                                onChange={(e) => onChange({ ...filters, onlyHourly: e.target.checked })}
                                className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                            />
                            <span className="text-sm text-gray-700">Only Hourly Projects</span>
                        </label>

                        <label className="flex items-center gap-2 cursor-pointer">
                            <input
                                type="checkbox"
                                checked={filters.onlyFixed || false}
                                onChange={(e) => onChange({ ...filters, onlyFixed: e.target.checked })}
                                className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                            />
                            <span className="text-sm text-gray-700">Only Fixed Price Projects</span>
                        </label>

                        <label className="flex items-center gap-2 cursor-pointer">
                            <input
                                type="checkbox"
                                checked={filters.hideNoBudget || false}
                                onChange={(e) => onChange({ ...filters, hideNoBudget: e.target.checked })}
                                className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                            />
                            <span className="text-sm text-gray-700">Hide projects without budget</span>
                        </label>
                    </div>

                </div>
            )}
        </div>
    );
}
